import { render, staticRenderFns } from "./HowWorksContent.vue?vue&type=template&id=8d20ee4c&"
import script from "./HowWorksContent.vue?vue&type=script&lang=js&"
export * from "./HowWorksContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports